/* eslint-disable import/no-extraneous-dependencies,import/no-unresolved */
import { collectWhenLoaded } from '@finn-no/navigation-timing';
import pulse from '@finn-no/pulse-sdk';
import * as braze from '@braze/web-sdk';
import controllerist from './controllerist';
import '@lit-labs/ssr-client/lit-element-hydrate-support.js';
import '../market-icons/elements';
import '@warp-ds/icons/elements';

function getEventTargetOptions(element) {
    const options = { id: element.getAttribute('href') };

    if (element.hasAttribute('data-page-link')) {
        options.type = 'Page';
    } else if (element.hasAttribute('data-external-link')) {
        options.type = 'ExternalContent';
        options.name = 'Go to webpage';
        options.provider = element.getAttribute('data-icon-name');
        options.referralCommission = false;
    } else {
        options.type = 'MarketFrontpage';
    }

    return options;
}

function addTrackingToMarketLinks() {
    document
        .querySelectorAll('[data-markets-pulse-wrapper] a')
        .forEach((element) => {
            const tracking = element.getAttribute('data-tracking-details');
            if (tracking) {
                const trackingData = JSON.parse(window.atob(tracking));
                element.addEventListener('click', () => {
                    pulse.trackEvent({
                        type: 'Click',
                        intent: 'Open',
                        name: trackingData.name,
                        object: {
                            type: 'UIElement',
                            elementType: trackingData.object.elementType,
                            position: trackingData.object.position,
                        },
                        target: trackingData.target,
                        vertical: trackingData.vertical,
                    });
                });
            } else {
                const eventTargetOptions = getEventTargetOptions(element);
                const iconName = element.getAttribute('data-icon-name');

                element.addEventListener('click', () => {
                    pulse.trackEvent({
                        type: 'Click',
                        intent: 'Open',
                        name: `Open ${iconName}`,
                        object: {
                            type: 'UIElement',
                            elementType: 'Market icon',
                        },
                        target: eventTargetOptions,
                    });
                });
            }
        });
}

function trackFrontpageBannerView() {
    const bannerElement = document.querySelector('#frontpage-banner');
    const cardId = bannerElement.getAttribute('card-id');
    return (
        bannerElement &&
        pulse.trackEvent({
            type: 'View',
            intent: 'Show',
            name: 'Braze content card',
            object: {
                type: 'UIElement',
                elementType: 'Card',
                position: 'Frontpage',
                name: cardId,
            },
            vertical: { name: 'common_pages' },
        })
    );
}

function trackFrontpageBannerButton() {
    const bannerLinkElement = document.querySelector('#frontpage-banner-link');
    const cardId = document
        .querySelector('#frontpage-banner')
        .getAttribute('card-id');

    bannerLinkElement.addEventListener('click', () => {
        pulse.trackEvent({
            type: 'Click',
            intent: 'Open',
            name: 'Braze content card',
            object: {
                type: 'UIElement',
                elementType: 'Button',
                position: 'Frontpage',
                name: cardId,
            },
            vertical: { name: 'common_pages' },
        });
    });
}

function performanceController() {
    const { host } = window.location;
    if (
        host.indexOf('dev.finn.no') === -1 &&
        host.indexOf('local.finn.no') === -1
    ) {
        collectWhenLoaded(
            'frontpage-podium',
            'https://www.finn.no/clientstats.html',
        );
    }
}

function addBraze() {
    const { brazeApiKey, brazeEndpointUrl, useBraze } =
        document.querySelector('#frontpage-content').dataset;
    if (useBraze !== 'true') return;
    braze.initialize(brazeApiKey, {
        baseUrl: brazeEndpointUrl,
    });
    braze.automaticallyShowInAppMessages();
    braze.changeUser(window.finnUserId);
    braze.openSession();
}

function main() {
    const c = controllerist();
    c.register('performance-timing', performanceController);

    c.run(document);

    if (navigator.serviceWorker) {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    }

    window.addEventListener('DOMContentLoaded', () => {
        pulse.trackPageView({
            object: {
                type: 'Frontpage',
            },
            vertical: {
                name: 'common_pages',
            },
        });

        addTrackingToMarketLinks();
        trackFrontpageBannerView();
        trackFrontpageBannerButton();
        addBraze();
    });
}

main();
